module.exports = __webpack_public_path__ + "asset/company-details-form--8ede37.png";